export interface CustomerKeyAndName {
  customerId: string;
  customerKey: string;
  customerName: string;
}
